import { useCallback, useState } from "react";

import type { FunctionResult } from "./types";

const MAX_HISTORY = 10;

/** Per-function result history (last 10 calls). Keyed by "contractAddress:functionName". */
export function useFunctionHistory(): {
  getHistory: (key: string) => FunctionResult[];
  addResult: (key: string, result: FunctionResult) => void;
} {
  const [history, setHistory] = useState<Record<string, FunctionResult[]>>({});

  const getHistory = useCallback(
    (key: string) => history[key] ?? [],
    [history],
  );

  const addResult = useCallback((key: string, result: FunctionResult) => {
    setHistory((prev) => {
      const existing = prev[key] ?? [];
      const next = [result, ...existing].slice(0, MAX_HISTORY);
      return { ...prev, [key]: next };
    });
  }, []);

  return { getHistory, addResult };
}
